export const formatTableName = (value: string): string =>
  value
    .replaceAll("_", " ")
    .replaceAll(/\b\w/g, (char) => char.toUpperCase());
